import { css } from "styled-components";
export const unFlowRootStyles = css `
  & {
    &,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    input,
    input:-webkit-autofill::first-line,
    input:-webkit-autofill {
      font-weight: normal;
      font-style: normal;
      font-size: initial;
      font-family: unset;

      color: unset;

      text-rendering: initial;
      -moz-osx-font-smoothing: initial;
      -webkit-font-smoothing: initial;

      line-height: normal;
    }
  }
`;
export default unFlowRootStyles;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidW5GbG93Um9vdFN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9taXhpbnMvdW5GbG93Um9vdFN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsR0FBRyxFQUFFLE1BQU0sbUJBQW1CLENBQUM7QUFFeEMsTUFBTSxDQUFDLE1BQU0sZ0JBQWdCLEdBQUcsR0FBRyxDQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQTBCbEMsQ0FBQztBQUVGLGVBQWUsZ0JBQWdCLENBQUMifQ==